export default function SET_SITE_MODERATORS(state, payload) {
  state.siteModerators.current = payload.origin.siteModerators;
}
